export default {"src":"/_next/static/media/discord.d259b66e.svg","height":800,"width":800};